import { J2Location } from '@e3dc-react/icons'
import React from 'react'
import { MarkerType } from '@e3dc-react/shell/src/Libs/Maps/types'
import { makeStyles } from 'tss-react/mui'

interface StyleProps {
  clickable: boolean
  cornerRadius: number
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  markerLocation: {
    cursor: props.clickable ? 'pointer' : 'grab',
    borderRadius: props.cornerRadius,
  },
  markerUser: {
    fontSize: '48px',
    borderRadius: props.cornerRadius,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}))
interface Props {
  lat: number
  lng: number
  src: string
  key: string
  type: MarkerType
  clickable: boolean
  installation?: unknown
  cornerRadius?: number
}

/**
 * Marker which symbolizes an installation
 */
const Marker: React.FC<Props> = ({ lat, lng, src, key, installation, clickable, type, cornerRadius = 0 }) => {
  const { classes } = useStyles({ clickable, cornerRadius })

  // @ts-expect-error lat&lng necessary for map but img doen't know these props
  // eslint-disable-next-line react/no-unknown-property
  if (type === 'user') return <J2Location fontSize="inherit" color="error" className={classes.markerUser} lat={lat} lng={lng} src={src} key={key} />
  // @ts-expect-error lat&lng necessary for map but img doen't know these props
  // eslint-disable-next-line react/no-unknown-property
  return <img alt="Map icon" width={40} className={classes.markerLocation} lat={lat} lng={lng} src={src} key={key} installation={installation} />
}

export default Marker
